module.exports = __webpack_public_path__ + "media/images/tennis-54dfed2bf2e434e3b34429a006fc3473.svg";